import api from "./interceptor";

const getAllHolidays = () => api.get(`/holidays`);
const createHoliday = (data) => api.post(`/holidays`, data);
const updateHoliday = (id, data) => api.put(`/holidays/${id}`, data);
const deleteHoliday = (id) => api.delete(`/holidays/${id}`);

export { getAllHolidays, createHoliday, updateHoliday, deleteHoliday };
